import React, {useState} from 'react'
import {Button} from 'antd'
import {Download} from 'lucide-react'
import {useTranslation} from 'react-i18next'

const normalizeUrl = value => {
    if (!value) return null

    const markdownMatch = String(value).match(/\]\((https?:\/\/.+)\)$/)
    return markdownMatch ? markdownMatch[1] : value
}

const clickDownloadLink = (href, fileName) => {
    const link = document.createElement('a')
    link.href = href
    link.download = fileName || 'version-file'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const downloadFile = async ({url, fileName}) => {
    try {
        const response = await fetch(url)
        if (!response.ok) throw new Error(`Download failed: ${response.status}`)

        const blob = await response.blob()
        const downloadUrl = URL.createObjectURL(blob)
        clickDownloadLink(downloadUrl, fileName)
        URL.revokeObjectURL(downloadUrl)
    } catch (error) {
        clickDownloadLink(url, fileName)
    }
}

const VersionDownloadButton = ({url, fileName, size}) => {
    const {t} = useTranslation()
    const [isDownloading, setIsDownloading] = useState(false)
    const normalizedUrl = normalizeUrl(url)

    if (!normalizedUrl) return '-'

    const handleClick = async () => {
        setIsDownloading(true)
        try {
            await downloadFile({url: normalizedUrl, fileName})
        } finally {
            setIsDownloading(false)
        }
    }

    return (
        <Button
            size={size}
            icon={<Download size={14}/>}
            loading={isDownloading}
            onClick={handleClick}
        >
            {t('pages.versions.detail.download')}
        </Button>
    )
}

export default VersionDownloadButton
